import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  BulkPatchDocumentTemplateType,
  DeleteDocumentTemplateType,
  DocumentDetails,
  DocumentTemplateType,
  getByIdDocumentTemplate,
  PatchDocumentTemplateType,
  PayloadGetDocumentTemplateByPageType,
} from '../types/documentTemplate.types'

const initialState: DocumentTemplateType<DocumentDetails> = {
  content: null,
  selected: null,
}

const documentTemplateSlice = createSlice({
  name: 'documentTemplate',
  initialState: initialState,
  reducers: {
    updateDocumentTemplateData: (state, action) => {
      state.content = action.payload
    },
    getAllDocumentTemplateAction: (
      state: DocumentTemplateType<DocumentDetails>,
      _action: PayloadAction<PayloadGetDocumentTemplateByPageType>
    ) => {
      return state
    },
    updateSelectedDocumentTemplate: (state, action) => {
      state.selected = action.payload
    },
    resetSelectedDocumentTemplate: (state) => {
      state.selected = null
    },
    createDocumentTemplateAction: (
      state: DocumentTemplateType<DocumentDetails>,
      _action
    ) => {
      return state
    },
    saveAsDraftDocumentTemplateAction: (
      state: DocumentTemplateType<DocumentDetails>,
      _action
    ) => {
      return state
    },
    fetchDocumentTemplateCodeAction: (
      state: DocumentTemplateType<DocumentDetails>,
      _action: PayloadAction<getByIdDocumentTemplate>
    ) => {
      return state
    },
    updateDocumentTemplateAction: (
      state: DocumentTemplateType<DocumentDetails>,
      _action
    ) => {
      return state
    },
    enableDisabletogglerDocumentTemplateAction: (
      state: DocumentTemplateType<DocumentDetails>,
      _action: PayloadAction<PatchDocumentTemplateType>
    ) => {
      return state
    },
    enableDisableBulktogglerDocumentTemplateAction: (
      state: DocumentTemplateType<DocumentDetails>,
      _action: PayloadAction<BulkPatchDocumentTemplateType>
    ) => {
      return state
    },
    deleteDocumentTemplateAction: (
      state: DocumentTemplateType<DocumentDetails>,
      _action: PayloadAction<DeleteDocumentTemplateType>
    ) => {
      return state
    },
  },
})

export const {
  getAllDocumentTemplateAction,
  createDocumentTemplateAction,
  updateDocumentTemplateAction,
  resetSelectedDocumentTemplate,
  fetchDocumentTemplateCodeAction,
  saveAsDraftDocumentTemplateAction,
  enableDisabletogglerDocumentTemplateAction,
  deleteDocumentTemplateAction,
  updateDocumentTemplateData,
  updateSelectedDocumentTemplate,
  enableDisableBulktogglerDocumentTemplateAction,
} = documentTemplateSlice.actions
export default documentTemplateSlice.reducer
